import { Button, Code, Container, Group, Stack, Text, Title } from '@mantine/core'
import { IconHome, IconRefresh } from '@tabler/icons-react'
import { Link } from '@tanstack/react-router'
import type { ErrorComponentProps } from '@tanstack/react-router'

export default function ErrorComponent({ error, info, reset }: ErrorComponentProps) {
  const message = error instanceof Error ? error.message : String(error)

  if (import.meta.env.DEV) {
    return (
      <Container size="lg" py="xl">
        <Stack gap="md">
          <Title order={2} c="red">
            Something went wrong
          </Title>
          <Text fw={600}>{message}</Text>

          {error instanceof Error && error.stack && (
            <Stack gap={4}>
              <Text size="sm" fw={600}>
                Stack Trace
              </Text>
              <Code block style={{ whiteSpace: 'pre-wrap', maxHeight: 400, overflow: 'auto' }}>
                {error.stack}
              </Code>
            </Stack>
          )}

          {info?.componentStack && (
            <Stack gap={4}>
              <Text size="sm" fw={600}>
                Component Stack
              </Text>
              <Code block style={{ whiteSpace: 'pre-wrap', maxHeight: 300, overflow: 'auto' }}>
                {info.componentStack}
              </Code>
            </Stack>
          )}

          <Group>
            <Button
              variant="light"
              leftSection={<IconRefresh size={18} stroke={1.5} />}
              onClick={reset}
            >
              Try Again
            </Button>
            <Button
              variant="subtle"
              component={Link}
              to="/"
              leftSection={<IconHome size={18} stroke={1.5} />}
            >
              Go Home
            </Button>
          </Group>
        </Stack>
      </Container>
    )
  }

  return (
    <Container size="sm" py="xl">
      <Stack gap="md" align="center">
        <Title order={2}>Something went wrong</Title>
        <Text c="dimmed" ta="center">
          An unexpected error occurred. Please try again or go back to the home page.
        </Text>
        <Group>
          <Button
            variant="light"
            leftSection={<IconRefresh size={18} stroke={1.5} />}
            onClick={reset}
          >
            Try Again
          </Button>
          <Button
            component={Link}
            to="/"
            leftSection={<IconHome size={18} stroke={1.5} />}
          >
            Go Home
          </Button>
        </Group>
      </Stack>
    </Container>
  )
}
